import { QueryKey } from '@/configs/queryKeys';
import { Project } from './ProjectApi';
import { AttributeValue } from './AttributeValueApi';
import { ProductModule } from './ProductModuleApi';
import { Preset } from './PresetApi';
import { UUID } from '@/types/types';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export interface CreatorProductModule extends BaseEntity {
	refId?: UUID;
	project?: Project;
	preset?: Preset;
	productModule?: ProductModule;
	productModuleId: UUID;
	selectedAttributeValues?: AttributeValue[];
	selectedAttributeValuesIds: UUID[];
	code: string;
	price: number;
	listOrder: number;
}

class CreatorProductModuleApi extends EntityApi<CreatorProductModule> {
	constructor() {
		super(QueryKey.creatorProductModules);
		this.swapProductModule = this.swapProductModule.bind(this);
	}

	async swapProductModule({
		id,
		productModule,
	}: {
		id: UUID;
		productModule: ProductModule;
	}) {
		const response = await httpClient.patch<CreatorProductModule>(
			`${this.queryKey}/${id}/swap-product-module`,
			{
				productModule,
			}
		);
		return response.data;
	}
}

export default new CreatorProductModuleApi();
